export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'jobs.delete_merchant',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:jobs:merchant:export',
    },
  },
}